import React, { useState, useEffect, Fragment, forwardRef } from "react";
import ResponseSwitcher from 'ReusableComponents/ResponseSwitcher';
import FormItem from "antd/es/form/FormItem";
import { Row, Col } from 'antd';
import Title from 'antd/es/typography/Title';
import cloneDeep from "lodash.clonedeep";

export default forwardRef((props: any, ref: any) => {
  const { form, inputData, questionsKey, language, onCheckAnswer, checkAnswer } = props,
    { required, questions, defaultValue, id, options: defaultOptions } = inputData,
    { getFieldDecorator } = form;
  const options = defaultOptions.map((defaultOption) => {
    return {
      value: defaultOption.value,
      label: defaultOption.text[language]
    }
  });
  const [state, setState] = useState({
    values: options.map((option) => option.value[0]),
    labels: options.map((option) => option.label),
  });

  const onChange = (index, selectedOption) => {
    const valuesClone = cloneDeep(state.values);
    valuesClone[index] = selectedOption.value;

    const labelsClone = cloneDeep(state.labels);
    labelsClone[index] = selectedOption.label;

    setState({ values: valuesClone, labels: labelsClone })
  }

  useEffect(() => {
    if (checkAnswer) {
      const value = state.labels.reduce((curr, prev)=>curr+prev);
      onCheckAnswer(id, value, questionsKey);
    }
  }, [checkAnswer])

  return (
    <FormItem
      colon={false}
    >
      <Title level={2}>
        <Row type="flex" justify="center">
          <Col span={16}>
            {options.map((option, index) => {
              const value = state.values[index];
              const label = state.labels[index];
              return (
                <Fragment key={index}>
                  <ResponseSwitcher value={value}
                                    label={label}
                                    options={options}
                                    onChange={(v,s)=>onChange(index,s[0])}
                  />
                </Fragment>
              )
            })}
          </Col>
        </Row>
      </Title>
    </FormItem>
  );
});
